import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import './BackpackGrid.css';

import BackpackGridHeader from './BackpackGridHeader.js';
import BackpackGridItem from './BackpackGridItem.js';

class BackpackGrid extends Component {
  clickedBackpackItem = (item) => {
    console.log('Clicked item:', item);
    let id = item.id;
    browserHistory.push(`/app/backpack/${id}`);
  }

  /**
   * Render a backpack item. Takes in the backpack item object from the service.
   *
   * @memberof BackpackGrid
   */
  renderItem = (item) => {
    const { id } = item;

    return (
      <BackpackGridItem key={id}
        item={item}
        checked={false}
        onCheckClick={null}
        onClick={this.clickedBackpackItem} />
    );
  }

  render() {
    const { items } = this.props;
    let itemCells = items.map(this.renderItem);

    return (
      <section className="BackpackGridContainer">
        <BackpackGridHeader />
        <ul className="BackpackGrid">
          {itemCells}
        </ul>
      </section>
    );
  }
}

export default BackpackGrid;



// WEBPACK FOOTER //
// ./src/components/BackpackGrid.js